import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { API_TAGS } from "../../helpers/constants";
import { IImg } from "../../types/Case";
import { ITRGMask } from "../../types/TRG";
import { caseApi } from "../case/api";
import { trgApi } from "../trg/api";

const initialState: {
  trgImage: IImg | null;
  trgMask: ITRGMask | null;
  isTRGImageLoading: boolean;
  isTRGMaskLoading: boolean;
  currentCaseId: number | null;
} = {
  trgImage: null,
  trgMask: null,

  isTRGImageLoading: false,
  isTRGMaskLoading: false,
  currentCaseId: null,
};

const trgSlice = createSlice({
  name: API_TAGS.TRG,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ---------------------------------------------------------------------
      .addMatcher(
        trgApi.endpoints.getCasesTRGSDelineationAI.matchPending,
        (state, action) => {
          state.isTRGMaskLoading = true;
        }
      )
      .addMatcher(
        trgApi.endpoints.getCasesTRGSDelineationAI.matchFulfilled,
        (state, action) => {
          state.trgMask = action.payload;
          state.isTRGMaskLoading = false;
        }
      )
      .addMatcher(
        trgApi.endpoints.getCasesTRGSDelineationAI.matchRejected,
        (state, action) => {
          state.trgMask = null;
          state.isTRGMaskLoading = false;
        }
      )

      .addMatcher(
        trgApi.endpoints.getCasesTRGSDelineation.matchPending,
        (state, action) => {
          state.isTRGMaskLoading = true;
        }
      )
      .addMatcher(
        trgApi.endpoints.getCasesTRGSDelineation.matchFulfilled,
        (state, action) => {
          state.trgMask = action.payload;
          state.isTRGMaskLoading = false;
        }
      )
      .addMatcher(
        trgApi.endpoints.getCasesTRGSDelineation.matchRejected,
        (state, action) => {
          state.trgMask = null;
          state.isTRGMaskLoading = false;
        }
      )
      // ---------------------------------------------------------------------
      .addMatcher(
        trgApi.endpoints.getTRGSImage.matchPending,
        (state, action) => {
          state.isTRGImageLoading = true;
        }
      )
      .addMatcher(
        trgApi.endpoints.getTRGSImage.matchFulfilled,
        (state, action) => {
          state.trgImage = action.payload;
          state.isTRGImageLoading = false;
        }
      )
      .addMatcher(
        trgApi.endpoints.getTRGSImage.matchRejected,
        (state, action) => {
          state.trgImage = null;
          state.isTRGImageLoading = false;
        }
      )
      // ---------------------------------------------------------------------
      .addMatcher(caseApi.endpoints.getCase.matchPending, (state, action) => {
        const caseId = Number(action.meta.arg.originalArgs);

        // Обнуляем изображение ТОЛЬКО при смене кейса, а не при обновлении того же кейса
        if (state.currentCaseId !== caseId) {
          console.log("TRG Slice: Case changed, clearing images", {
            oldCaseId: state.currentCaseId,
            newCaseId: caseId,
          });
          state.trgImage = null;
          state.trgMask = null;
          state.currentCaseId = caseId;
        } else {
          console.log("TRG Slice: Same case, keeping images", {
            caseId,
          });
        }
      });
  },
});

export const {} = trgSlice.actions;
export default trgSlice.reducer;
